import { CharStatus } from '../../lib/statuses'
import classnames from 'classnames'
import { WORD_COUNT } from '../../constants/countSpecific'
import { WORD_LENGTH, REVEAL_TIME_MS } from '../../constants/settings'
import { getStoredIsHighContrastMode } from '../../lib/localStorage'

type Props = {
  value?: string
  status?: CharStatus
  isRevealing?: boolean
  isCompleted?: boolean
  position?: number
  isValid?: boolean
}

export const Cell = ({
  value,
  status,
  isRevealing,
  isCompleted,
  position = 0,
  isValid = true,
}: Props) => {
  const isFilled = value && !isCompleted
  const shouldReveal = isRevealing && isCompleted
  const animationDelay = `${position * REVEAL_TIME_MS}ms`
  const isHighContrast = getStoredIsHighContrastMode()

  const classes = classnames(
    'border-solid border-2 flex items-center justify-center mx-0.5 font-bold rounded dark:text-white',
    'font-mono',
    {
      'bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-600':
        !status,
      'border-black dark:border-slate-100': value && !status,
      'absent shadowed bg-slate-400 dark:bg-slate-700 text-white border-slate-400 dark:border-slate-700':
        status === 'absent',
      'correct shadowed bg-orange-500 text-white border-orange-500':
        status === 'correct' && isHighContrast,
      'present shadowed bg-cyan-500 text-white border-cyan-500':
        status === 'present' && isHighContrast,
      'correct shadowed bg-green-500 text-white border-green-500':
        status === 'correct' && !isHighContrast,
      'present shadowed bg-yellow-500 text-white border-yellow-500':
        status === 'present' && !isHighContrast,
      'otherword shadowed bg-violet-600 text-white border-violet-600':
        status === 'otherword' && isHighContrast,
      'otherword shadowed bg-violet-500 text-white border-violet-500':
        status === 'otherword' && !isHighContrast,
      'cell-fill-animation': isFilled,
      'cell-reveal': shouldReveal,
      'border-red-500 dark:border-red-500': !isValid,
      'ml-4': position !== 0 && position % WORD_LENGTH === 0,
      'ml-2 sm:ml-4':
        position !== 0 && position % WORD_LENGTH === 0 && WORD_COUNT > 2,

      'w-14 h-14 text-4xl': WORD_COUNT === 2,
      'w-8 h-8 text-xl sm:h-8 sm:w-12 sm:text-2xl md:h-14 md:w-14 md:text-4xl border-1 mx-px':
        WORD_COUNT === 3,
      'w-8 h-6 text-sm sm:h-6 sm:w-12 sm:text-md md:h-14 md:w-14 md:text-4xl border-1 mx-px sm:mx-0.5':
        WORD_COUNT === 4,
      'w-8 h-5 text-xs sm:h-4 sm:w-12 sm:text-md md:h-14 md:w-14 md:text-4xl border-1 mx-px sm:mx-0.55':
        WORD_COUNT === 5,
    }
  )

  return (
    <div className={classes} style={{ animationDelay }}>
      <div className="letter-container" style={{ animationDelay }}>
        {value}
      </div>
    </div>
  )
}
